module.exports = __webpack_public_path__ + "img/lv_failure_3.3eba7eb2.png";